import client1 from "../assets/images/clients/client-1.svg";
import client2 from "../assets/images/clients/client-2.svg";
import client3 from "../assets/images/clients/client-3.svg";
import client4 from "../assets/images/clients/client-4.svg";
import client5 from "../assets/images/clients/client-5.svg";
import client6 from '../assets/images/clients/client-6.jpeg';
import client7 from '../assets/images/clients/client-7.jpeg';
import client8 from '../assets/images/clients/client-8.jpeg';
import client9 from '../assets/images/clients/client-9.jpeg';

// Define subscription plans in an array
export const plans = [
    {
        id: "hobbyist-plan",
        name: "Hobbyist Plan",
        plan_name: "Hobbyist Plan",
        price: 550,
        duration: "year",
        priceId: "price_1R7cfjDOERxX1mfPOjhIn5uq",
        plan_description: "Ideal For: Independent Producers",
        features: [
            "$1000/each for 5 clearances (savings of $2,500)",
            "$50/each for 10 clearance analysis (savings of $500)",
            "10 songs analyzed for clearance costs, likelihood of clearance, time required, etc.",
        ],
        details:
            "Ideal for smaller projects or individual producers, this plan offers single clearance services for either publishing or sound recording rights. Perfect for those just starting out or needing limited clearance.",
    },
    {
        id: "pro-plan",
        plan_name: "Pro Plan",
        price: 1000,
        duration: "year",
        priceId: "price_1R7ci1DOERxX1mfPqPJSa4dQ",
        plan_description: "In exchange for a $1,000 fee, Ample Samples™ members are granted access to:",
        features: [
            "$1000/each for 20 clearances (savings of $10,000)",
            "$500 discount per clearance for subscribed users",
            "10 songs analyzed for clearance costs, likelihood of clearance, time required, etc.",
            "1 Monthly Consultation",
            "Reduced clearance rates for a period of one calendar year or for up to twenty (20) clearances, whichever occurs first.\n\nSound Recording and Publishing rights"
        ],
        recommended: true,
        details:
            "For those needing both sound recording and publishing rights, the Pro plan provides access to our full sample library and priority clearance processing, ensuring faster turnaround times for larger projects.",
    },
    {
        id: "enterprise",
        plan_name: "Enterprise",
        price: null,
        plan_description: "Contact us for Pricing",
        features: [
            "Custom licensing solutions tailored to large-scale projects.",
            "Dedicated account manager and legal support.",
            "Contact us: Please direct to hello@thesampl.es"
        ],
        contact: true,
        contactLink: "mailto:hello@thesampl.es",
        details:
            "For large-scale projects or organizations, the Enterprise plan offers custom pricing and dedicated account support. Our team will work with you to tailor a solution that fits your needs, providing legal support and full-service management of your clearance process.",
    },
];

export const oneTimePlans = [
    {
        id: "single-sample-review",
        plan_name: "Sample Review",
        price: 100,
        duration: "1 Review",
        priceId: "price_1UEYb5RcQlcCZ3ONol2ZTPUi",
        plan_description: "Producers, artists and labels that need clear, reliable guidance before releasing their songs.",
        features: [
            "Record is analyzed for clearance costs, likelihood of clearance, time required, etc",
            "Let Ample Samples™ review your music to determine if there are samples, estimate clearance cost, timing, and rights so you can move forward with confidence."
        ],
        details:
            "Ideal for smaller projects or individual producers, this plan offers single clearance services for either publishing or sound recording rights. Perfect for those just starting out or needing limited clearance.",
    },
    {
        id: "full-clearance-package",
        plan_name: "Sample Clearance",
        price: 1500, // Base price - $500 discount applied for subscribed users
        duration: "1 Songs",
        priceId: "price_1U3GBWRcQlcCZ3ONr8oxPRxe",
        plan_description: "Brands, filmmakers, producers, artists, and labels who need fast, reliable music licensing.",
        features: [
            "Fast and accurate sync and sample clearance — done right the first time.",
            "$1,500 per clearance [$750 now & on completion]",
            "$1,000 per clearance w/Membership  [$500 now & on completion]"
        ],
        // recommended: true,
        details:
            "For those needing both sound recording and publishing rights, the Pro plan provides access to our full sample library and priority clearance processing, ensuring faster turnaround times for larger projects.",
    },
    {
        id: "digital-license",
        plan_name: "Digital license",
        price: 400, // Base price - $500 discount applied for subscribed users
        duration: "1 License",
        priceId: "price_1UEYbdRcQlcCZ3ONAXYxPU9b",
        plan_description: "Artists, producers, labels, and content creators who need fast, reliable clearance for digital releases, music videos and online campaigns.",
        features: [
            "We secure the rights you need for distributing your remake and music video of any existing song so your music and content stay compliant and monetized."
        ],
        // recommended: true,
        details:
            "For those needing both sound recording and publishing rights, the Pro plan provides access to our full sample library and priority clearance processing, ensuring faster turnaround times for larger projects.",
    },
    // {
    // id: "cover-song-cleared",
    // name: "Cover Song Cleared",
    // price: 400,
    // duration: "1 Song",
    // description: "Ideal For: Independent Artists & Labels",
    // features: [""],
    // // contact: true,
    // details:
    //   "For large-scale projects or organizations, the Enterprise plan offers custom pricing and dedicated account support. Our team will work with you to tailor a solution that fits your needs, providing legal support and full-service management of your clearance process.",
    // },
];

/**
 * The sync clearance product. Kept out of `oneTimePlans` because shop-item
 * renders that array as buyable tiles and a sync is only ever bought through
 * the sync wizard. It names no `priceId`: a sync is billed as an amount-only
 * invoice line, so its catalog row carries a placeholder price key that a real
 * Stripe price would change, and checkout resolves the id from the one active
 * `sync` row instead. The API routes the clearance payload by that product
 * type, so a sync billed as a sample is written into the sample tables.
 */
export const syncClearancePlan = {
    id: "sync-clearance",
    plan_name: "Sync Clearance",
    price: 750,
    duration: "1 Sync",
    plan_description: "Brands, filmmakers, producers, artists, and labels who need fast, reliable music licensing.",
};

/** Ample Samples Lite & Pro – package page tiles and comparison table */
export const membershipPackages = [
    {
        id: "ample-samples-pro",
        name: "Ample Samples Pro",
        badge: "Best Value",
        price: 500,
        description: "Built for albums, catalogs, and serious release schedules.",
        note: "Our most popular plan for artists, labels, and producers clearing at scale.",
        membershipFee: 500,
        costPerClearance: 1000,
        numberOfClearances: 15,
        totalCost: 15500,
        totalSavings: 7000,
        features: [
            "Up to **15 songs** eligible for clearance",
            "**$1,000 per song** member rate",
            "Save **$7,000** vs. non-members",
            "Priority intake + accelerated review",
        ],
        priceId: "price_1T2xoyRcQlcCZ3ON4UrA4deu",
        slug: "pro",
        colorTheme: "green",
        order: 1,
        ctaLabel: "Upgrade to Pro",
    },
    {
        id: "ample-samples-lite",
        name: "Ample Samples Lite",
        badge: null,
        price: 250,
        priceId: "price_1T2xrBRcQlcCZ3ON6AlIZKzL",
        slug: "lite",
        description: "Perfect for singles, EPs, and short-run projects.",
        note: "Ideal for artists testing a release or clearing a small batch.",
        membershipFee: 250,
        costPerClearance: 1000,
        numberOfClearances: 5,
        totalCost: 5250,
        totalSavings: 2250,
        features: [
            "Up to **5 songs** eligible for clearance",
            "**$1,000 per song** member rate",
            "Save **$2,250** vs. non-members",
            "Priority intake review",
        ],
        colorTheme: "blue",
        order: 2,
        ctaLabel: "Get Lite membership",
    },
    {
        id: "ample-samples-enterprise",
        name: "Ample Samples Enterprise",
        badge: null,
        hidePrice: true,
        hideSummary: true,
        excludeFromComparison: true,
        description:
            "For global brands, corporations, and agencies producing high-volume content and campaigns.",
        note: null,
        letsTalkTitle: "Let's Talk!",
        letsTalkBody:
            "Email us at info@thesampl.es to discuss enterprise pricing.",
        features: [
            "Managing music across multiple campaigns or platforms?",
            "Need fast, reliable clearance for branded content, advertising, or experiential use?",
            "Releasing content at scale with tight timelines?",
        ],
        colorTheme: "neutral",
        order: 3,
        ctaLabel: "Email for Enterprise",
        ctaMailto: "info@thesampl.es",
    },
];

export const testimonialsData = [
    {
        name: "Wayne Barrow",
        subLabel: "",
        description: `“They are music purists who approach clearance from a musicologist’s standpoint, with detailed precision, execution and delivery.”`,
        writtenBy: `– Wayne Barrow, President / Bystorm Entertainment.`,
    },
    // {
    //   name: "Kobie Brown",
    //   subLabel: "",
    //   description: `“They understand sample questions deserve simple answers”`,
    //   writtenBy: `– Kobie Brown / Vice President / Licensing / Sony Music`,
    // },
    {
        name: "Jeff Robinson",
        subLabel: "",
        description: `“They don't just clear samples. They know music, and understand its history and culture.”`,
        writtenBy: `– Jeff Robinson / MBK Entertainment`,
    },
    {
        name: "JABARI",
        subLabel: "",
        description: `As a creator having the right partner to navigate the licensing process is essential. Ample Samples™ has been that
partner for me every step of the way.`,
        writtenBy: `— JABARI, Founder & CEO, COLORS Worldwide / R&B ONLY`,
    },
    {
        name: "Kei Henderson",
        subLabel: "",
        description: `Ample Samples™ is incredibly speedy, knowledgeable and thorough.`,
        writtenBy: `– Kei Henderson / Third & Hayden`,
    },
];

export const clientsData = [
    {
        src: client1,
    },
    {
        src: client2,
    },
    {
        src: client3,
    },
    {
        src: client4,
    },
    {
        src: client5,
    },
    {
        src: client6
    },
    {
        src: client7
    },
    {
        src: client8
    },
    {
        src: client9
    },
];
